import { AppThunkAction } from '../reducers';
import * as jwt_decode from 'jwt-decode';

// services
import * as Services from '../../services/CashFlow-Debts.Services';
import * as AccountServices from '../../services/CashFlow-Accounts.Services';

// actions
import * as Actions from '../actions';
import * as ActionEvents from '../actions/CashFlow-Debt.Actions';

// models
import { Debt } from '../../models/Entities/CashFlow/Debt/Debt';
import { ErrorType } from '../../models/HttpError';
import { NewDebt } from '../../models/Entities/CashFlow/Debt/NewDebt';
import { DebtIndicators } from '../../models/Entities/CashFlow/Debt/DebtIndicators';

type KnownAction =
    | Actions.CashFlowDebts.CashFlowDebtGetAllAsCreditorRequestAction
    | Actions.CashFlowDebts.CashFlowDebtGetAllAsCreditorSuccessAction
    | Actions.CashFlowDebts.CashFlowDebtGetAllAsCreditorFailureAction
    | Actions.CashFlowDebts.CashFlowDebtGetAllAsDebtorRequestAction
    | Actions.CashFlowDebts.CashFlowDebtGetAllAsDebtorSuccessAction
    | Actions.CashFlowDebts.CashFlowDebtGetAllAsDebtorFailureAction
    | Actions.CashFlowDebts.CashFlowDebtUpdateAllAsCreditorRequestAction
    | Actions.CashFlowDebts.CashFlowDebtUpdateAllAsCreditorSuccessAction
    | Actions.CashFlowDebts.CashFlowDebtUpdateAllAsCreditorFailureAction
    | Actions.CashFlowDebts.CashFlowDebtUpdateAllAsDebtorRequestAction
    | Actions.CashFlowDebts.CashFlowDebtUpdateAllAsDebtorSuccessAction
    | Actions.CashFlowDebts.CashFlowDebtUpdateAllAsDebtorFailureAction
    | Actions.CashFlowDebts.CashFlowDebtGetbyIdRequestAction
    | Actions.CashFlowDebts.CashFlowDebtGetByIdSuccessAction
    | Actions.CashFlowDebts.CashFlowDebtGetByIdFailureAction
    | Actions.CashFlowDebts.CashFlowDebtGetBySettlementIdRequestAction
    | Actions.CashFlowDebts.CashFlowDebtGetBySettlementIdSuccessAction
    | Actions.CashFlowDebts.CashFlowDebtGetBySettlementIdFailureAction
    | Actions.CashFlowDebts.CashFlowDebtCheckPaidRequestAction
    | Actions.CashFlowDebts.CashFlowDebtCheckPaidSuccessAction
    | Actions.CashFlowDebts.CashFlowDebtCheckPaidFailureAction
    | Actions.CashFlowDebts.CashFlowDebtCheckStatusRequestAction
    | Actions.CashFlowDebts.CashFlowDebtCheckStatusSuccessAction
    | Actions.CashFlowDebts.CashFlowDebtCheckStatusFailureAction
    | Actions.CashFlowDebts.CashFlowDebtGetIndicatorsRequestAction
    | Actions.CashFlowDebts.CashFlowDebtGetIndicatorsSuccessAction
    | Actions.CashFlowDebts.CashFlowDebtGetIndicatorsFailureAction
    | Actions.CashFlowDebts.CashFlowDebtCreateRequestAction
    | Actions.CashFlowDebts.CashFlowDebtCreateSuccessAction
    | Actions.CashFlowDebts.CashFlowDebtCreateFailureAction
    | Actions.CashFlowDebts.CashFlowDebtUpdateRequestAction
    | Actions.CashFlowDebts.CashFlowDebtUpdateSuccessAction
    | Actions.CashFlowDebts.CashFlowDebtUpdateFailureAction
    | Actions.CashFlowDebts.CashFlowDebtDeleteRequestAction
    | Actions.CashFlowDebts.CashFlowDebtDeleteSuccessAction
    | Actions.CashFlowDebts.CashFlowDebtDeleteFailureAction;

export const actionCreators = {
    GetAllDebtsByCreditor: (Creditor: string, Debtor: string | undefined): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_GETALLAS_CREDITOR_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            })
            return;
        }

        dispatch({
            type: ActionEvents.CASHFLOW_DEBT_GETALLAS_CREDITOR_REQUEST
        });

        Services.GetDebtsByCreditor(token, Creditor, Debtor)
            .then((response: Debt[]) => {
                dispatch({
                    type: ActionEvents.CASHFLOW_DEBT_GETALLAS_CREDITOR_SUCCESS,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.CASHFLOW_DEBT_GETALLAS_CREDITOR_FAILURE,
                    error: error
                });
            });
    },
    GetAllDebtsByDebtor: (Debtor: string, Creditor: string | undefined): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_GETALLAS_DEBTOR_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            })
            return;
        }

        dispatch({
            type: ActionEvents.CASHFLOW_DEBT_GETALLAS_DEBTOR_REQUEST
        });

        Services.GetDebtsByDebtor(token, Debtor, Creditor)
        .then((response: Debt[]) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_GETALLAS_DEBTOR_SUCCESS,
                payload: response
            });
        })
        .catch((error: ErrorType) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_GETALLAS_DEBTOR_FAILURE,
                error: error
            });
        });
    },
    GetDebtById: (debtId: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_GETBYID_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            })
            return;
        }

        const currentOwner: string = (jwt_decode.jwtDecode(token) as any)?.tenantId;

        dispatch({
            type: ActionEvents.CASHFLOW_DEBT_GETBYID_REQUEST,
            payload: debtId
        });

        Services.GetDebtById(token, debtId)
        .then((response) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_GETBYID_SUCCESS,
                tenantId: currentOwner,
                payload: response
            });
        })
        .catch((error) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_GETBYID_FAILURE,
                error: error
            });
        });

    },
    CreateDebt: (debt: NewDebt): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_CREATE_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            })
            return;
        }

        const currentOwner: string = (jwt_decode.jwtDecode(token) as any)?.tenantId;

        dispatch({
            type: ActionEvents.CASHFLOW_DEBT_CREATE_REQUEST,
            payload: debt
        });

        Services.CreateDebt(token, debt)
        .then((response) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_CREATE_SUCCESS,
                tenantId: currentOwner,
                payload: response
            });
        })
        .catch((error) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_CREATE_FAILURE,
                error: error
            });
        });

    },
    UpdateDebt: (debt: Debt): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_UPDATE_FAILURE,
                debtId: debt.id,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            })
            return;
        }

        const currentOwner: string = (jwt_decode.jwtDecode(token) as any)?.tenantId;

        dispatch({
            type: ActionEvents.CASHFLOW_DEBT_UPDATE_REQUEST,
            tenantId: currentOwner,
            payload: debt
        });

        Services.UpdateDebt(token, debt)
        .then((debt: Debt) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_UPDATE_SUCCESS,
                tenantId: currentOwner,
                payload: debt
            });
        })
        .catch((error) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_UPDATE_FAILURE,
                debtId: debt.id,
                error: error
            });
        });

    },
    DeleteDebt: (debtId: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_DELETE_FAILURE,
                debtId: debtId,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            })
            return;
        }

        dispatch({
            type: ActionEvents.CASHFLOW_DEBT_DELETE_REQUEST,
            payload: debtId
        });

        Services.DeleteDebt(token, debtId)
        .then((response) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_DELETE_SUCCESS,
                payload: debtId
            });
        })
        .catch((error) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_DELETE_FAILURE,
                debtId: debtId,
                error: error
            });
        });

    },
    UpdateAllDebtsByCreditor: (Creditor: string, Debtor: string | undefined): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_UPDATEALLAS_CREDITOR_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            })
            return;
        }

        dispatch({
            type: ActionEvents.CASHFLOW_DEBT_UPDATEALLAS_CREDITOR_REQUEST
        });

        Services.GetDebtsByCreditor(token, Creditor, Debtor)
            .then((response: Debt[]) => {
                dispatch({
                    type: ActionEvents.CASHFLOW_DEBT_UPDATEALLAS_CREDITOR_SUCCESS,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.CASHFLOW_DEBT_UPDATEALLAS_CREDITOR_FAILURE,
                    error: error
                });
            });
    },
    UpdateAllDebtsByDebtor: (Debtor: string, Creditor: string | undefined): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_UPDATEALLAS_DEBTOR_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            })
            return;
        }

        dispatch({
            type: ActionEvents.CASHFLOW_DEBT_UPDATEALLAS_DEBTOR_REQUEST
        });

        Services.GetDebtsByDebtor(token, Debtor, Creditor)
        .then((response: Debt[]) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_UPDATEALLAS_DEBTOR_SUCCESS,
                payload: response
            });
        })
        .catch((error: ErrorType) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_UPDATEALLAS_DEBTOR_FAILURE,
                error: error
            });
        });
    },
    GetDebtsBySettlementId: (settlementId: number, currencyCode?: string, onlyActive: boolean = true): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_GETBYSETTLEMENTID_FAILURE,
                settlementId: settlementId,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            })
            return;
        }

        dispatch({
            type: ActionEvents.CASHFLOW_DEBT_GETBYSETTLEMENTID_REQUEST,
            settlementId: settlementId
        });

        Services.GetDebtsBySettlementId(token, settlementId, currencyCode, onlyActive)
        .then((response: Debt[]) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_GETBYSETTLEMENTID_SUCCESS,
                settlementId: settlementId,
                payload: response
            });
        })
        .catch((error: ErrorType) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_GETBYSETTLEMENTID_FAILURE,
                settlementId: settlementId,
                error: error
            });
        });

    },
    CheckDebtPaid: (debtId: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_CHECKPAID_FAILURE,
                debtId: debtId,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.CASHFLOW_DEBT_CHECKPAID_REQUEST,
            debtId: debtId
        });

        Services.CheckDebtPaid(token, debtId)
        .then((response: boolean) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_CHECKPAID_SUCCESS,
                debtId: debtId,
                payload: response
            });
        })
        .catch((error: ErrorType) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_CHECKPAID_FAILURE,
                debtId: debtId,
                error: error
            });
        });

    },
    CheckDebtStatus: (debtId: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_CHECKSTATUS_FAILURE,
                debtId: debtId,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.CASHFLOW_DEBT_CHECKSTATUS_REQUEST,
            debtId: debtId
        });

        Services.CheckDebtStatus(token, debtId)
        .then((response: boolean) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_CHECKSTATUS_SUCCESS,
                debtId: debtId,
                payload: response
            });
        })
        .catch((error: ErrorType) => {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_CHECKSTATUS_FAILURE,
                debtId: debtId,
                error: error
            });
        });

    },
    GetDebtIndicatorsByUserId: (userId?: string): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_GETINDICATORS_FAILURE,
                userId: userId || '',
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        const currentTenantId: string = (jwt_decode.jwtDecode(token) as any)?.tenantId;
        const finalUserId = userId || currentTenantId;

        if (!finalUserId) {
            dispatch({
                type: ActionEvents.CASHFLOW_DEBT_GETINDICATORS_FAILURE,
                userId: '',
                error: {
                    ErrorCode: 400,
                    ErrorMessage: 'User id not found',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.CASHFLOW_DEBT_GETINDICATORS_REQUEST,
            userId: finalUserId
        });

        AccountServices.GetDebtIndicatorsByUserId(token, finalUserId)
            .then((response: DebtIndicators) => {
                dispatch({
                    type: ActionEvents.CASHFLOW_DEBT_GETINDICATORS_SUCCESS,
                    userId: finalUserId,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.CASHFLOW_DEBT_GETINDICATORS_FAILURE,
                    userId: finalUserId,
                    error: error
                });
            });
    }
};

